import React, { useState, useContext, useEffect } from "react";
import Select from "../common/selectcustom";
import Powerchart from "../chart/powerchart";
// import TableReport from "./renderreport";
import ScrollToTop from "../common/ScrollToTop";
import Header from "../common/headerlist";
import ChartOnprocess from "../chart/donut";
import {  monthdata } from "../common/datalist";
import {
  getYear,
  getPerformace,
  getPerFormacePerMonth,
  getPerformaceMinutes,
  getPerformaceMinutesPermonth,
  getOnProcessDetails,
  getOnProcessOverDays
} from "../../services/dashboard";
import {
  productgroup,trucklistgroup
} from "../../services/wms";

import BranchContext from "../context/branch";

const Reportpower = () => {
  const { currentBranch } = useContext(BranchContext);
  const [loading, setloading] = useState(false);
  const [yearlist, setyearlist] = useState([]);
  const [datalist1, setdatalist1] = useState([]);
  const [datalist2, setdatalist2] = useState([]);
  const [datalist3, setdatalist3] = useState([]);
  const [datalist4, setdatalist4] = useState([]);
  const [datalist5, setdatalist5] = useState([]);
  const [datagraph1, setdatagraph1] = useState([]);
  const [datagraph2, setdatagraph2] = useState([]);
  const [datagraph3, setdatagraph3] = useState([]);
  const [datagraph4, setdatagraph4] = useState([]);
  const [datagraph5, setdatagraph5] = useState([]);
  const [datalist, setdatalist] = useState([]);

  const [yearid, setyearid] = useState(0);
  const [monthid, setmonthid] = useState(0);
  const [list, setlist] = useState([]);
  const [trucklist, settrucklist] = useState([]);
  const [truckid, setruckid] = useState(0);
  const [productid, setproductid] = useState(0);
  const [formload, setformload] = useState(false);
  const [eventclick, seteventclick] = useState(false);
  const monthist = monthdata;

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getYear(
        currentBranch && currentBranch._id
      );

      if (result) {
        setyearlist(result);
        setformload(true);
        if (result.length > 0) {
          setyearid(result[0]._id);
        }
      }
    };
    loadData();
  }, [currentBranch]);



  useEffect(() => {
    if (!currentBranch) return; 
    if (currentBranch._id === "0" || currentBranch._id === "") return;
  
  ;
   
    const loadData = async () => {
      const { data: result } = await productgroup(currentBranch._id);
      if (result) {
     
        setlist(result);
      
      }
    };
    loadData();
  }, [currentBranch]);
  
  
  useEffect(() => {
    if (!currentBranch) return; 
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    
  ;
 
    const loadData = async () => {
      const { data: result } = await trucklistgroup(currentBranch._id);
      if (result) {
     
        settrucklist(result);
      
      }
    };
    loadData();
  }, [currentBranch]);



  useEffect(() => {
    if (!currentBranch) return;
    if (!formload) return;
    const loadData = async () => {
      const { data: result } = await getPerformace(
        currentBranch && currentBranch._id,
        yearid,
        monthid,
        productid,
        truckid
      );

      if (result) {
        setdatalist1(result);
      }
    };
    loadData();
  }, [currentBranch, formload, yearid, monthid, productid, truckid]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!formload) return;
    const loadData = async () => {
      const { data: result } = await getPerFormacePerMonth(
        currentBranch && currentBranch._id,
        yearid,
        monthid,
        productid,
        truckid
      );

      if (result) {
        setdatalist2(result);
      }
    };
    loadData();
  }, [currentBranch, formload, yearid, monthid, productid, truckid]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!formload) return;
    const loadData = async () => {
      const { data: result } = await getPerformaceMinutes(
        currentBranch && currentBranch._id,
        yearid,
        monthid,
        productid,
        truckid
      );

      if (result) {
        setdatalist3(result);
      }
    };
    loadData();
  }, [currentBranch, formload, yearid, monthid, productid, truckid]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!formload) return;
    
    const loadData = async () => {
      const { data: result } = await getPerformaceMinutesPermonth(
        currentBranch && currentBranch._id,
        yearid,
        monthid,
        productid,
        truckid
      );

      if (result) {
        setdatalist4(result);
      }
    };
    loadData();
  }, [currentBranch, formload, yearid, monthid, productid, truckid]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!formload) return;
    const loadData = async () => {
      const { data: result } = await getOnProcessOverDays(
        currentBranch && currentBranch._id,
        productid,
        truckid
      );
      if (result.status === "success") {
        setdatalist5([result.data.total]);
      }
    };
    loadData();
  }, [currentBranch, formload, productid, truckid]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!formload) return;
    if (!eventclick) return;

    const loadData = async () => {
      const { data: result } = await getOnProcessDetails(
        currentBranch && currentBranch._id,
        productid,
        truckid
      );
      if (result) {
        setdatalist(result);
      }
    };
    loadData();
  }, [currentBranch, formload, productid, truckid, eventclick]);

  useEffect(() => {
    if (!datalist1 || !currentBranch) return;
    const chart = () => {
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let data4 = [];
      let categorie = [];

      for (const dataObj of datalist1) {
        categorie.push(dataObj.name);
        data1.push(parseInt(dataObj.id1));
        data2.push(parseInt(dataObj.id2));
        data3.push(parseInt(dataObj.id3));
        data4.push(parseInt(dataObj.id4));
      }

      const data = {
        series: [
          {
            name: "< 60 นาที",
            data: data1,
            color: "#008000",
          },
          {
            name: "60-90 นาที",
            data: data2,
            color: "#32CD32",
          },
          {
            name: "90-120 นาที",
            data: data3,
            color: "#FFA500",
          },
          {
            name: "> 120 นาที",
            data: data4,
            color: "#DC143C",
          },
        ],
        dataLabels: {
          enabled: true,
          formatter: function (val, opt) {
            return opt.w.globals.series[opt.seriesIndex][opt.dataPointIndex];
          },
        },
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          stackType: "100%",
          width: "100%",
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },

        xaxis: {
          categories: categorie,
          labels: {
            formatter: function (val) {
              return val + "%";
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "T.";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
      };
      setdatagraph1(data);
    };
    chart();
  }, [datalist1, currentBranch]);

  useEffect(() => {
    if (!datalist2 || !currentBranch) return;
    const chart = () => {
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let data4 = [];
      let categorie = [];

      for (const dataObj of datalist2) {
        categorie.push(dataObj.name);
        data1.push(parseInt(dataObj.id1));
        data2.push(parseInt(dataObj.id2));
        data3.push(parseInt(dataObj.id3));
        data4.push(parseInt(dataObj.id4));
      }

      const data = {
        series: [
          {
            name: "น้อยกว่า 60 นาที",
            data: data1,
            color: "#008000",
          },
          {
            name: "ระหว่าง 60-90 นาที",
            data: data2,
            color: "#32CD32",
          },
          {
            name: "ระหว่าง 90-120 นาที",
            data: data3,
            color: "#FFA500",
          },
          {
            name: "มากกว่า 120 นาที",
            data: data4,
            color: "#DC143C",
          },
        ],
        dataLabels: {
          enabled: true,
          formatter: function (val, opt) {
            return opt.w.globals.series[opt.seriesIndex][opt.dataPointIndex];
          },
        },
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          stackType: "100%",
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },

        xaxis: {
          categories: categorie,
          labels: {
            formatter: function (val) {
              return val + "%";
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "T.";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
      };
      setdatagraph2(data);
    };
    chart();
  }, [datalist2, currentBranch]);

  useEffect(() => {
    if (!datalist3 || !currentBranch) return;
    const chart = () => {
      const final = [];
      datalist3.map((c) =>
        final.push({
          x: c["name"],
          y: c["timesminute"],
          goals: [
            {
              name: "KPI",
              value: 60,
              strokeWidth: 3,
              strokeColor: "#08090C",
            },
          ],
        })
      );
      const data = {
        series: [
          {
            name: "ผลลัพท์",
            data: final,
          },
        ],
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        colors: ["#1D62EE"],
        dataLabels: {
          formatter: function (val, opt) {
            const goals =
              opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
                .goals;

            if (goals && goals.length) {
              return `${val}`;
            }
            return val;
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Avg นาที/หาง", "KPI 60 นาที"],
          markers: {
            fillColors: ["#1D62EE", "#08090C"],
          },
        },
      };

      setdatagraph3(data);
    };
    chart();
  }, [datalist3, currentBranch]);

  useEffect(() => {
    if (!datalist4 || !currentBranch) return;

    const chart = () => {
      const final = [];
      datalist4.map((c) =>
        final.push({
          x: c["name"],
          y: c["timesminute"],
          goals: [
            {
              name: "KPI",
              value: 60,
              strokeWidth: 3,
              strokeColor: "#08090C",
            },
          ],
        })
      );
      const data = {
        series: [
          {
            name: "ผลลัพท์",
            data: final,
          },
        ],
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        colors: ["#1D62EE"],
        dataLabels: {
          formatter: function (val, opt) {
            const goals =
              opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
                .goals;

            if (goals && goals.length) {
              return `${val}`;
            }
            return val;
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Avg นาที/หาง", "KPI 60 นาที"],
          markers: {
            fillColors: ["#1D62EE", "#08090C"],
          },
        },
      };
      setdatagraph4(data);
    };
    chart();
  }, [datalist4, currentBranch]);

  function getNewData(baseval, yrange) {
    var newTime = baseval + 300000;
    return {
      x: newTime,
      y: Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min,
    };
  }

  useEffect(() => {
    if (!datalist5 || !currentBranch) return;
    if (datalist5.length === 0) return;
    const chart = () => {
      let phour = [];
      let AmountA = [];

      phour.push("ทังหมด (" + datalist5 + ")");
      AmountA.push(parseInt(datalist5));

      if (!datalist5) return;

      const data = {
        options: {
          tooltip: {
            enabled: true,
          },
          chart: {
            background: "transparent",
            animations: {
              enabled: false,
              easing: "easeinout",
              speed: 500,
              animateGradually: {
                enabled: true,
                delay: 150,
              },
              dynamicAnimation: {
                enabled: false,
                speed: 350,
              },
            },
            dropShadow: {
              enabled: false,
              enabledOnSeries: undefined,
              top: 0,
              left: 0,
              blur: 3,
              color: "#000",
              opacity: 0.3,
            },
          },
          states: {
            hover: {
              filter: {
                type: "none",
              },
            },
            active: {
              filter: {
                type: "none",
              },
            },
          },
          stroke: {
            show: true,
          },
          legend: {
            show: true,
          },
          plotOptions: {
            pie: {
              startAngle: 0,
              expandOnClick: true,
              offsetX: 0,
              offsetY: 0,
              customScale: 1,
              dataLabels: {
                offset: 0,
                minAngleToShowLabel: 10,
              },
              donut: {
                labels: {
                  show: true,
                  total: {
                    showAlways: true,
                    show: true,
                  },
                },
              },
            },
          },

          fill: {
            type: "fill",
          },
          labels: phour,
        },
        series: AmountA,
      };
      setdatagraph5(data);
    };
    chart();
  }, [datalist5, currentBranch]);

  const handleChangeTruck = ({ name, item, classname }) => {
    const clear = [...trucklist];

    const index1 = clear.findIndex((x) => x.classname === "btn btn-primary");
    if (index1 > -1) {
      clear[index1].classname = "btn btn-outline-dark";
      settrucklist(clear);
    }
    const subobject = {
      _id: item,
      name: name,
      classname: "btn btn-primary",
    };
    const sub = [...trucklist];
    const index = sub.findIndex((x) => x._id === item);
    sub[index] = subobject;
    settrucklist(sub);
    setruckid(item);
    seteventclick(false)
  };

  const handleProductChange = ({ name, item, classname }) => {
    const clear = [...list];

    const index1 = clear.findIndex((x) => x.classname === "btn btn-primary");
    if (index1 > -1) {
      clear[index1].classname = "btn btn-outline-dark";
      setlist(clear);
    }
    const subobject = {
      _id: item,
      name: name,
      classname: "btn btn-primary",
    };
    const sub = [...list];
    const index = sub.findIndex((x) => x._id === item);
    sub[index] = subobject;
    setlist(sub);
    setproductid(item);
    seteventclick(false)
  };

  const handleChange = (event) => {
    setyearid(event.currentTarget.value);
    seteventclick(false)
  };
  const handleMonthChange = (event) => {
    setmonthid(event.currentTarget.value);
    seteventclick(false)
  };
const handleClick = (event) => {
  seteventclick(true)
}
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-3  col-sm-4 col-xs-12">
          <div className="form-group">
            <Select
              label="ปี"
              data={yearlist}
              value={yearid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="col-lg-3  col-sm-4 col-xs-12">
          <div className="form-group">
            <Select
              label="เดือน"
              data={monthist}
              value={monthid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleMonthChange}
            />
          </div>
        </div>
        <div className="col-auto me-2">
         <i>
            กลุ่มสินค้า 
          </i>
          <div className="m-1 " style={{ marginTop: 20, marginBottom: 20 }}>
            <Header
              list={list}
              onChange={handleProductChange}
              disabled={loading}
            />
          </div>
        </div>
        <div className="col-auto  ms-4">
         <i>
            กลุ่มรถบรรทุก
          </i>
          <div className="m-1 " style={{ marginTop: 20, marginBottom: 20 }}>
            <Header
              list={trucklist}
              onChange={handleChangeTruck}
              disabled={loading}
            />
          </div>
        </div>
      </div>
      <div className="card">
        <button
          type="button"
          className="border-0 text-primary"
          style={{
            fontSize: "24px",
            background: "#EAECEE",
            fontWeight: "bold",
          }}
        >
          ภาพการลงแยกรายเชื้อเพลิง
        </button>
      </div>

      <div className="row">
        <div className="col-lg-6 ">
          {datagraph3.series !== undefined && (
            <Powerchart options={datagraph3} />
          )}
        </div>

        <div className="col-lg-6 ">
          {datagraph1.series !== undefined && (
            <Powerchart options={datagraph1} />
          )}
        </div>
      </div>
      <div className="card">
        <button
          type="button"
          className="border-0 text-primary "
          style={{
            fontSize: "24px",
            background: "#EAECEE",
            fontWeight: "bold",
          }}
        >
          ภาพการลงแยกรายเดือน
        </button>
      </div>
      <div className="row">
        <div className="col-lg-6 ">
          {datagraph4.series !== undefined && (
            <Powerchart options={datagraph4} />
          )}
        </div>
        <div className="col-lg-6">
          {datagraph2.series !== undefined && (
            <Powerchart options={datagraph2} />
          )}
        </div>

        <div className="col-lg-6 col-xs-12">
          <div className="mt-1">
            <div className="card">
              <div className="card-header text-center">
                {"จำนวนรถค้างทั้งหมด"}
              </div>
              <div className="card-body text-center">
                <div className="mt-1">
                  {datagraph5.series !== undefined &&
                    datagraph5 &&
                    datagraph5.series.length > 0 && (
                      <ChartOnprocess onClick = {handleClick} data={datagraph5} />
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
       
      
      </div>
      <ScrollToTop />
      {/* {eventclick &&  <div className="col-lg-12">
        <TableReport
        list ={datalist}
         />

        </div>} */}
    </div>
  );
};

export default Reportpower;
